'use client';

import * as React from 'react';
import Image from 'next/image';
import styles from './styles.module.scss';
import ActiveLink from '@/components/ui/ActiveLink';
import Link from 'next/link';

export type IHeaderLink = {
  href: string;
  label: React.ReactNode;
  target?: string;
  openInNewTab?: boolean;
};

export interface IHeaderProps {
  siteName: string;
  logoDesktop: {
    width: number;
    height: number;
    src: string;
  };
  logoMobile: {
    width: number;
    height: number;
    src: string;
  };
  links: IHeaderLink[];
  tickets?: React.ReactNode;
  buttons?: React.ReactNode;
}

const Header: React.FunctionComponent<IHeaderProps> = (props) => {
  return (
    <div className={styles['header']}>
      <div className={styles['header__row-1']}>
        <div className={styles['header__limiter']}>
          <div className={styles['header__logo']}>
            <Link href="/">
              <Image
                alt={props.siteName}
                src={props.logoDesktop.src}
                width={props.logoDesktop.width}
                height={props.logoDesktop.height}
                className={styles['header__logo__desktop']}
              />
              <Image
                alt={props.siteName}
                src={props.logoMobile.src}
                width={props.logoMobile.width}
                height={props.logoMobile.height}
                className={styles['header__logo__mobile']}
              />
            </Link>
          </div>
          {props.tickets}
          {props.buttons}
        </div>
      </div>
      <div className={styles['header__row-2']}>
        <div className={styles['header__limiter']}>
          {props.links && props.links.length > 0 && (
            <ul className={styles['header__links']}>
              {props.links.map((link, linkIndex) => (
                <li key={linkIndex}>
                  <ActiveLink
                    exact={true}
                    href={link.href}
                    target={link.openInNewTab ? '_blank' : link.target}
                    rel="noopener noreferrer"
                    onClick={(e) => {
                      if (link.href.startsWith('#')) {
                        const target = link.href.substring(1);
                        const elem = document.getElementById(target);
                        if (elem) {
                          e.preventDefault();
                          elem.scrollIntoView({
                            block: 'start',
                            behavior: 'smooth',
                          });
                        }
                      }
                    }}
                  >
                    {link.label}
                  </ActiveLink>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

Header.displayName = 'Header';

export default Header;
